export const BTL_MANAGER_CREATE = 'BTL_MANAGER_CREATE';
export const BTL_MANAGER_CREATE_START = 'BTL_MANAGER_CREATE_START';
export const BTL_MANAGER_CREATE_SUCCESS = 'BTL_MANAGER_CREATE_SUCCESS';
export const BTL_MANAGER_CREATE_FAILED = 'BTL_MANAGER_CREATE_FAILED';

export const BTL_MANAGER_UPDATE = 'BTL_MANAGER_UPDATE';
export const BTL_MANAGER_UPDATE_START = 'DTL_MANAGER_UPDATE_START';
export const BTL_MANAGER_UPDATE_SUCCESS = 'BTL_MANAGER_UPDATE_SUCCESS';
export const BTL_MANAGER_UPDATE_FAILED = 'BTL_MANAGER_UPDATE_FAILED';
